import React from 'react';
import PropTypes from 'prop-types';
import RoutedHeader from '../Header';
import BaseFilteredList from '../BaseFilteredList';
import FilterItemType from '../BaseFilteredList/FilterItemType';
import FilterDateRange from '../BaseFilteredList/FilterDateRange';

const History = ({
  children,
  itemTypeOpts,
  onItemTypeChange,
  itemTypeSelected,
  onFromChange,
  dateMin,
  fromSelected,
  onToChange,
  dateMax,
  toSelected,
  mediaQueryValues,
  LoadingComponent,
  isLoading,
}) => {
  const filters = [
    {
      Comp: FilterItemType,
      props: {
        onChange: onItemTypeChange,
        itemTypeSelected,
        options: itemTypeOpts,
      },
    },
    {
      Comp: FilterDateRange,
      props: {
        onChange: onItemTypeChange,
        onFromChange,
        min: dateMin,
        fromSelected,
        onToChange,
        max: dateMax,
        toSelected,
      },
    },
  ];
  return (
    <div>
      <RoutedHeader />
      {
        isLoading ?
          <LoadingComponent /> :
          <BaseFilteredList
            hideBorder
            listLabel="Transactions"
            filters={filters}
            mediaQueryValues={mediaQueryValues}
          >
            { children }
          </BaseFilteredList>
      }
    </div>
  );
};

History.propTypes = {
  itemTypeOpts: PropTypes.arrayOf(PropTypes.string),
  itemTypeSelected: PropTypes.string,
  onItemTypeChange: PropTypes.func,
  dateMin: PropTypes.string,
  fromSelected: PropTypes.string,
  onFromChange: PropTypes.func,
  dateMax: PropTypes.string,
  toSelected: PropTypes.string,
  onToChange: PropTypes.func,
  mediaQueryValues: PropTypes.shape({}),
  LoadingComponent: PropTypes.func,
  isLoading: PropTypes.bool,
};

History.defaultProps = {
  itemTypeOpts: ['All Transactions'],
  itemTypeSelected: 'All Transactions',
  onItemTypeChange: () => {},
  dateMin: '',
  fromSelected: '',
  onFromChange: () => {},
  dateMax: '',
  toSelected: '',
  onToChange: () => {},
  mediaQueryValues: {},
  LoadingComponent: () => (<div />),
  isLoading: false,
};

export default History;



// WEBPACK FOOTER //
// ./src/components/History/History.js